export const apiNames = {
  emergencyPlanType: 'emergencyPlanType',
  emergencyTaskStatus: 'emergencyTaskStatus',
  emergencyTaskLogType: 'emergencyTaskLogType',
  alarmLevel: "alarmLevel",
  device: 'device',
  deviceCategory: 'deviceCategory',
  parameterDataType: 'parameterDataType',
  parameterUnit: 'parameterUnit',
  parameterAlarmCode: 'parameterAlarmCode',
  deviceState: 'deviceState',
  deviceType: 'deviceType',
  workflowScheme: 'workflowScheme',
  workflowForm: 'workflowForm',
  cycleType: 'cycleType',
  frequencyType: 'frequencyType',
  inspectionTaskState: 'inspectionTaskState',
  scadaProcessType: 'scadaProcessType'
}